import Close from '@components/icons/Close/Close'
import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock'
import cn from 'clsx'
import {
  Children,
  FC,
  isValidElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react'
import styles from './Modal.module.scss'
interface ModalProps {
  className?: string
  children?: React.ReactNode[]
  onClose: () => void
  onEnter?: () => void | null
  setOnClose?: React.Dispatch<React.SetStateAction<() => void>>
  forceAction?: boolean
}

const Modal: FC<ModalProps> = ({
  children,
  onClose,
  setOnClose,
  forceAction,
}) => {
  const [fullscreen, setFullScreen] = useState<'mobile' | 'expanded'>()
  const ref = useRef() as React.MutableRefObject<HTMLDivElement>
  const handleKey = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !forceAction) {
        return onClose()
      }
    },
    [onClose],
  )

  useEffect(() => {
    const modal = ref.current

    if (modal && !forceAction) {
      disableBodyScroll(modal, { reserveScrollBarGap: true })
      window.addEventListener('keydown', handleKey)
    }
    return () => {
      clearAllBodyScrollLocks()
      window.removeEventListener('keydown', handleKey)
    }
  }, [handleKey])

  return (
    <div
      className={cn(styles.root, fullscreen && styles.fullscreen, {
        [styles.noBackdrop]: forceAction,
      })}
    >
      {/* <ClickOutside active={true} onClick={() => onClose()}> */}
      <div
        className={cn(
          styles.modal,
          { [styles.wrapper]: fullscreen === 'mobile' },
          { [styles['wrapper-full']]: fullscreen === 'expanded' },
        )}
        role="dialog"
        ref={ref}
      >
        {!forceAction && (
          <button
            onClick={() => onClose()}
            aria-label="Close panel"
            className={styles.close}
          >
            <Close className="h-6 w-6" />
          </button>
        )}

        {Children.map(children, (child, index) => {
          if (isValidElement(child)) {
            return {
              ...child,
              props: {
                ...child.props,
                setFullScreen,
                setOnClose,
              },
            }
          }
          return child
        })}
      </div>
      {/* </ClickOutside> */}
    </div>
  )
}

export default Modal
